"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.customerApiClientFactory = customerApiClientFactory;
const infra_1 = require("../infra");
const axios_client_1 = require("@invivodf/axios-client");
function customerApiClientFactory(apiHost, options) {
    const client = (0, axios_client_1.createAxiosClient)(apiHost, options);
    const pathCustomer = (partnerId, customerNumber) => `/v1/partners/${partnerId}/memberships/${customerNumber}`;
    const newPathCutomer = (partnerId, customerNumber) => `/v1/partners/${partnerId}/customers/${customerNumber}`;
    const pathPartnerCustomerSegments = (partnerId) => `/v1/partners/${partnerId}/segments`;
    const pathCustomerSegments = (partnerId, customerCode) => `/v1/partners/${partnerId}/customers/${customerCode}/segments`;
    const pathCustomerPossibleSegments = (partnerId, customerCode) => `/v1/partners/${partnerId}/customers/${customerCode}/segments`;
    const pathCustomersByTechnician = (partnerId, technicianId) => `/v1/partners/${partnerId}/customers/${technicianId}/sales`;
    const pathCooperativeMemberSegmentation = (partnerId) => `/v1/cooperatives/${partnerId}/member-segmentation`;
    const pathCustomerAssociatedAccount = (partnerId, customerCode) => `/v2/partners/${partnerId}/customers/${customerCode}/associated-accounts`;
    async function getCustomer(params) {
        try {
            const response = await client.get(pathCustomer(params.partnerId, params.customerNumber));
            return response.data;
        }
        catch (err) {
            (0, infra_1.handleError)(err);
        }
    }
    async function getCustomerPaymentMethods(params) {
        try {
            const response = await client.get(`${pathCustomer(params.partnerId, params.customerNumber)}/payment-methods`);
            return response.data;
        }
        catch (err) {
            (0, infra_1.handleError)(err);
        }
    }
    async function getCustomersByTechnician(params) {
        try {
            const queries = [
                params.limit ? `limit=${params.limit}` : null,
                params.page ? `page=${params.page}` : null,
                params.registered ? `registered=${params.registered}` : null,
                params.membershipsNumbers ? `memberships_numbers=${params.membershipsNumbers}` : null,
                params.search ? `search=${params.search}` : null,
                params.orderNotificationOnly ? `orderNotificationOnly=${params.orderNotificationOnly}` : null
            ].reduce((acc, item) => {
                if (!acc && item)
                    return `?${item}`;
                else if (item)
                    return `${acc}&${item}`;
                return acc;
            }, '');
            const response = await client.get(`${pathCustomersByTechnician(params.partnerId, params.technicianId)}${queries}`);
            return response.data;
        }
        catch (err) {
            (0, infra_1.handleError)(err);
        }
    }
    async function getSegmentations(partnerId) {
        try {
            const response = await client.get(pathPartnerCustomerSegments(partnerId));
            return response.data;
        }
        catch (err) {
            (0, infra_1.handleError)(err);
        }
    }
    async function getCustomerSegmentations(partnerId, memberCode) {
        try {
            const response = await client.get(pathCustomerSegments(partnerId, memberCode));
            return response.data;
        }
        catch (err) {
            (0, infra_1.handleError)(err);
        }
    }
    async function retrievesDynamicCustomerSegmentation(partnerId, memberCode, carts) {
        try {
            const response = await client.post(pathCustomerSegments(partnerId, memberCode), carts);
            return response.data;
        }
        catch (err) {
            (0, infra_1.handleError)(err);
        }
    }
    async function retrieveAllPossibleSegments(partnerId, customerCode) {
        try {
            const response = await client.get(pathCustomerPossibleSegments(partnerId, customerCode));
            return response.data;
        }
        catch (err) {
            (0, infra_1.handleError)(err);
        }
    }
    async function getCustomerContacts(partnerId, memberCode) {
        try {
            const response = await client.get(`${newPathCutomer(partnerId, memberCode)}/contacts`);
            return response.data;
        }
        catch (err) {
            (0, infra_1.handleError)(err);
        }
    }
    async function getCustomerStores(partnerId, membershipNumber) {
        try {
            const response = await client.get(`${newPathCutomer(partnerId, membershipNumber)}/stores`);
            return response.data;
        }
        catch (err) {
            (0, infra_1.handleError)(err);
        }
    }
    async function getMemberSegmentation(partnerId, opts) {
        try {
            let url = pathCooperativeMemberSegmentation(partnerId);
            // Add query parameter if member_code is provided
            if (opts?.member_code) {
                url += `?member_code=${opts.member_code}`;
            }
            const response = await client.get(url);
            return response.data;
        }
        catch (err) {
            (0, infra_1.handleError)(err);
        }
    }
    async function getCustomerAssociatedAccount(partnerId, customerCode) {
        try {
            const url = pathCustomerAssociatedAccount(partnerId, customerCode);
            const response = await client.get(url);
            return response.data;
        }
        catch (err) {
            (0, infra_1.handleError)(err);
        }
    }
    async function createCustomer(distributorId, payload) {
        try {
            const response = await client.post(`/v1/distributors/${distributorId}/customers`, payload);
            return response.data;
        }
        catch (err) {
            (0, infra_1.handleError)(err);
        }
    }
    async function getCustomerByExternalReference(params) {
        const result = await getCustomersByDistributor({
            distributorId: params.distributorId,
            externalReference: params.externalReference,
            limit: 1
        });
        return result.data[0] ?? null;
    }
    async function getCustomersByDistributor(params) {
        try {
            const queryParams = new URLSearchParams();
            if (params.limit !== undefined)
                queryParams.append('limit', params.limit.toString());
            if (params.page !== undefined)
                queryParams.append('page', params.page.toString());
            if (params.status !== undefined)
                queryParams.append('status', params.status);
            if (params.includeDeleted !== undefined)
                queryParams.append('includeDeleted', params.includeDeleted.toString());
            if (params.externalReference !== undefined)
                queryParams.append('externalReference', params.externalReference);
            if (params.registrationNumber !== undefined)
                queryParams.append('registrationNumber', params.registrationNumber);
            if (params.search !== undefined)
                queryParams.append('search', params.search);
            const queryString = queryParams.toString();
            const url = `/v1/distributors/${params.distributorId}/customers${queryString ? `?${queryString}` : ''}`;
            const response = await client.get(url);
            const customers = response.data;
            const totalCount = response.status === 206 && response.headers['content-range']
                ? +response.headers['content-range'].split('/')[1]
                : customers.length;
            return { data: customers, totalCount };
        }
        catch (err) {
            (0, infra_1.handleError)(err);
        }
    }
    return {
        getCustomer,
        getCustomerPaymentMethods,
        getCustomersByTechnician,
        getCustomerSegmentations,
        retrievesDynamicCustomerSegmentation,
        retrieveAllPossibleSegments,
        getSegmentations,
        getCustomerContacts,
        getCustomerStores,
        getMemberSegmentation,
        getCustomerAssociatedAccount,
        createCustomer,
        getCustomersByDistributor,
        getCustomerByExternalReference
    };
}
